import type { ComponentDefinition } from "../types";

// LiTime 12.8V 230Ah Plus Low-Temp user manual, pp2–3; checked 2026-10-19.
// https://cdn.shopify.com/s/files/1/0667/7220/5788/files/LiTime_12.8V_230Ah_Battery_-_User_Manual.pdf?v=1754645432
export const LITIME_BATTERIES: ComponentDefinition[] = [
  {
    id: "batt-litime-plus-230",
    name: "LiTime 12V 230Ah Plus LiFePO4",
    shortName: "Plus 230Ah",
    subtitle: "Low-temp protected house battery",
    category: "battery",
    manufacturer: "LiTime",
    model: "12.8V 230Ah Plus Low-Temp (200A BMS)",
    voltage: 12.8,
    capacityAh: 230,
    chemistry: "lifepo4",
    maxChargeA: 200,
    maxDischargeA: 200,
    width: 215,
    height: 80,
    terminals: [
      {
        id: "pos",
        label: "+",
        polarity: "positive",
        direction: "bidi",
        maxAmp: 200,
        side: "left",
        offset: 0.5,
      },
      {
        id: "neg",
        label: "−",
        polarity: "negative",
        direction: "bidi",
        maxAmp: 200,
        side: "right",
        offset: 0.5,
      },
    ],
  },
];
